import { useState } from "react";
import { useTranslation } from "react-i18next";

import IosSwitch from "../IosSwitch";

interface ISocialProfile {
    allowsSocialProfile: 0 | 1;
    handleChange: (value: boolean) => void;
}

const SocialProfile = ({ allowsSocialProfile, handleChange }: ISocialProfile) => {
    const [t] = useTranslation();

    const [allowed, setAllowed] = useState(allowsSocialProfile === 0 ? false : true);

    const handleToggleChange = (value: boolean) => {
        setAllowed((prev: boolean) => !prev);
        handleChange(value);
    };

    return (
        <div className="info-block stock-setting">
            <div className="info-block-head">
                <div className="info-block-head-name">{t("CompanySettings.BeneficiaryPortal")}</div>
            </div>
            <div className="info-block-list">
                <div className="info-block-list-element show-stock-movement">
                    <div className="label">{t("CompanySettings.SocialProfile")}</div>
                    <div className="switch">
                        <IosSwitch checked={allowed} onChange={(e: any) => handleToggleChange(e.target.checked)} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocialProfile;
